import React from 'react'
import { BrowserRouter,Routes,Route  } from 'react-router-dom'
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Error from './pages/Error';
import Yoga from './ExtraPages/Yoga';
import Gym24 from './ExtraPages/Gym24';
import AllEquip from './ExtraPages/AllEquip';
import Trainers from './ExtraPages/Trainers';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Navbar from './pages/Navbar';
const App = () => {
  return (
   <>
   <BrowserRouter>
   <Routes>
     {/* <Route index element={<Navbar/>}> */}
    <Route path="/" element={<Home/>}/>
    <Route path="/about" element={<About/>}/>
    <Route path="/contact" element={<Contact/>}/>
    <Route path="*" element={<Error/>}/>
    <Route path="/yoga" element={<Yoga/>}/>
    
 <Route path="/yoga" element={<Yoga/>}/>
    <Route path="/gym24" element={<Gym24/>}/>
    <Route path="/allequip" element={<AllEquip/>}/>
    <Route path="/trainers" element={<Trainers/>}/>


   
   

   </Routes>
  
   </BrowserRouter>
   </>
  )
}

export default App